import { SortingState } from "@tanstack/react-table";

export const createOrderingParam = (sorting?: SortingState) => {
  return (sorting || [])
    .map(
      (v) => `${v.desc ? "-" : ""}${v.desc ? v.id.replaceAll(",", ",-") : v.id}`
    )
    .join(",");
};
